/**
 * SimCardArt - Card image with a name fallback for simulated cards
 *
 * Shared by the full-size hand tiles and the compact turn-timeline thumbnails.
 */
import type { ReactElement } from 'react';

import type { SimCard } from '@/features/decks/lib/handSim';

export interface SimCardArtProps {
  card: SimCard;
  /** Font size class for the fallback name, matched to the tile size */
  fallbackClassName?: string;
}

export default function SimCardArt({ card, fallbackClassName = 'text-[9px]' }: SimCardArtProps): ReactElement {
  if (!card.imageUris?.normal) {
    return (
      <div className={`bg-slate text-ash flex h-full w-full items-center justify-center px-1 text-center ${fallbackClassName}`}>
        {card.name}
      </div>
    );
  }

  return <img src={card.imageUris.normal} alt={card.name} className="h-full w-full object-cover" loading="lazy" />;
}
